import { useStaticQuery, graphql } from 'gatsby';

import { getMarketData } from './helpers';
import commodities from './commodities';

const useMarketData = () => {
  const queryResponse = useStaticQuery(graphql`
    query {
      wordpressPage(wordpress_id: { eq: 17461 }) {
        content
      }
    }
  `);
  return {
    commodities,
    ...getMarketData(queryResponse),
  };
};

export { useMarketData };
